module.exports = new __parcel__URL__("7557-2.ac6b246f.png").toString();